import {InitPage} from "../../index";
import {ProductionCalendar} from "../../../../assets/javascripts/App/production_calendar";

declare global {
    // tslint:disable-next-line: interface-name
    interface Window {
        ProductionCalendar: ProductionCalendar;
    }
}

export function LoadPage() {
    InitPage("production_calendar", () => {
        if ($(".planning-calendar").length > 0) {
            window.ProductionCalendar = new ProductionCalendar();
            window.ProductionCalendar.initCells();
        }
    });
}

